import { DataService } from './dataService'

export const PlanService = {
    getPlans: async (data) => {
        return DataService.get('/admin/plan/list', data)
    },
    addPlan: async (data) => {
        return DataService.post('/admin/plan/add', data)
    },
    updatePlan: async (data) => {
        return DataService.put('/admin/plan/update', data)
    },
    deletePlan: async (data) => {
        return DataService.post('/admin/plan/delete', data)
    },
    getAddons: async (data) => {
        return DataService.get('/admin/addon/list', data)
    },
    addAddon: async (data) => {
        return DataService.post('/admin/addon/add', data)
    },
    updateAddon: async (data) => {
        return DataService.put('/admin/addon/update', data)
    },
    deleteAddon: async (data) => {
        return DataService.post('/admin/addon/delete', data)
    }
}
